// Brand palette sampled directly from the East Anglia Pickleball logo:
// teal #169BB6, lime #B6D329.
export const colors = {
  bg: "#F5FAFA",
  bgCard: "#FFFFFF",
  border: "rgba(22,155,182,0.18)",
  borderStrong: "rgba(22,155,182,0.35)",
  teal: "#169BB6",
  tealDark: "#0E7A91",
  tealTint: "rgba(22,155,182,0.08)",
  lime: "#B6D329",
  limeDark: "#7C9420",
  limeTint: "rgba(182,211,41,0.15)",
  accent: "#169BB6",
  accent2: "#7C9420",
  text: "#16323A",
  textDim: "#5C7B82",
  textFaint: "#8FA6AB",
  danger: "#C6473C",
  dangerBg: "rgba(198,71,60,0.08)",
  dangerBorder: "rgba(198,71,60,0.3)",
  success: "#7C9420",
  successBg: "rgba(124,148,32,0.1)",
  successBorder: "rgba(124,148,32,0.3)",
};

export const inputStyle = {
  width: "100%", boxSizing: "border-box",
  background: "#FFFFFF",
  border: "1px solid " + colors.borderStrong,
  borderRadius: 8, color: colors.text,
  padding: "11px 14px", fontSize: 14,
  outline: "none", fontFamily: "inherit",
};

export const btnStyle = {
  width: "100%", padding: "12px",
  background: colors.teal,
  border: "none", borderRadius: 8,
  color: "#fff", fontWeight: 800,
  fontSize: 15, cursor: "pointer",
  fontFamily: "inherit", letterSpacing: 0.5,
};

export const btnSecondaryStyle = {
  width: "100%", padding: "12px",
  background: "#fff",
  border: "1px solid " + colors.borderStrong,
  borderRadius: 8,
  color: colors.text, fontWeight: 700,
  fontSize: 15, cursor: "pointer",
  fontFamily: "inherit", letterSpacing: 0.5,
};

export const linkStyle = {
  background: "none", border: "none",
  color: colors.teal, cursor: "pointer",
  fontSize: 13, textDecoration: "underline",
  fontFamily: "inherit", padding: 0,
};

export const cardStyle = {
  background: colors.bgCard,
  border: "1px solid " + colors.border,
  borderRadius: 16, padding: "24px 22px",
  boxShadow: "0 1px 3px rgba(22,155,182,0.08)",
};

export const labelStyle = {
  fontSize: 11, color: colors.textDim, marginBottom: 5,
  textTransform: "uppercase", letterSpacing: 1,
};

export const pageWrap = {
  minHeight: "100vh",
  fontFamily: "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif",
  color: colors.text,
  maxWidth: 640,
  margin: "0 auto",
  padding: "20px 16px 60px",
};
